/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APITokenVerifyRequest
 */
export interface APITokenVerifyRequest {
    /**
     * 
     * @type {string}
     * @memberof APITokenVerifyRequest
     */
    token: string;
}

/**
 * Check if a given object implements the APITokenVerifyRequest interface.
 */
export function instanceOfAPITokenVerifyRequest(value: object): value is APITokenVerifyRequest {
    if (!('token' in value) || value['token'] === undefined) return false;
    return true;
}

export function APITokenVerifyRequestFromJSON(json: any): APITokenVerifyRequest {
    return APITokenVerifyRequestFromJSONTyped(json, false);
}

export function APITokenVerifyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APITokenVerifyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'],
    };
}

export function APITokenVerifyRequestToJSON(value?: APITokenVerifyRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'token': value['token'],
    };
}

